








































































import { Component, Prop, Vue } from "vue-property-decorator";
import TreeView from './TreeView.vue';
import CreasesView from './CreasesView.vue';
import PackingView from './PackingView.vue';
import { BAlert, BButton, BSpinner, ModalPlugin, NavbarPlugin } from 'bootstrap-vue';
import { CreasesGraphState } from '../engine/packing';

Vue.component('b-alert', BAlert)
Vue.component('b-button', BButton);
Vue.component('b-spinner', BSpinner);
Vue.use(ModalPlugin);
Vue.use(NavbarPlugin);
 
@Component({
  components: {
    TreeView,
    CreasesView,
    PackingView
  }
})
export default class TreeFaker extends Vue {
  generatingPacking = false;

  async generatePacking() {
    //this.generatingPacking = true;
    //this.$forceUpdate();
    (this.$refs as any).tree.propagate();
    await (this.$refs as any).packing.pack();
    //this.generatingPacking = false;
  }
  getCreasePattern() {
    (this.$refs as any).creases.show();
  }
  exportFold() {
    (this.$refs as any).creases.download();
  }
  origamiSimulator() {
    (this.$refs as any).creases.origamiSimulator();
  }
  get creasesDisabled() {
      return (this.$store as any).state.creasesGraph === undefined;
  }
  get exportDisabled() {
    return (
      //(this.$store as any).state.creasesGraph === undefined ||
      //(this.$store as any).state.creasesGraph.state !== CreasesGraphState.FullyAssigned
      false
    );
  }
  get inErrorState() {
    return (this.$store as any).state.globalError !== undefined;
  }
  get errorMessage() {
    return (this.$store as any).state.globalError;
  }
}
